/**
 * Ленивая загрузка ECharts. Компоненты графиков импортируют только этот модуль; сам движок приезжает
 * динамическим `import()` при первом показе графика. Промис общий: второй график не грузит движок повторно.
 * В тестах модуль подменяется (`vi.mock('./echartsLoader')`), canvas в jsdom не нужен.
 */

import type { EChartsType } from 'echarts/core'

export interface EChartsRuntime {
  init: (
    dom: HTMLElement,
    theme?: string | object | null,
    opts?: { renderer?: 'canvas' | 'svg'; locale?: string },
  ) => EChartsType
}

let runtime: Promise<EChartsRuntime> | null = null

export function loadECharts(): Promise<EChartsRuntime> {
  if (!runtime) {
    runtime = import('./echartsSetup')
      .then((module) => module.echarts as unknown as EChartsRuntime)
      .catch((error) => {
        // Сбой загрузки чанка (например, после выкладки) не должен «залипнуть» навсегда.
        runtime = null
        throw error
      })
  }
  return runtime
}
